import { fluidSize } from './fluidSize';

const primitives = {
  global: {
    black: '#000',
    white: '#fff',
  },
  brand: {
    red: { DEFAULT: '#E71C35', light950: '#FEF4F5', light850: '#FBDDE1' },
    orange: { dark150: '#D95C28', light150: '#FF824E', light950: '#FFF8F5' },
    green: { DEFAULT: '#68A439', dark50: '#74B740', light650: '#D0E9BD' },
    stripe: {
      main: '#C8102E',
      secondary: '#78BE20',
      tertiary: '#C4D600',
      quaternary: '#FFD700',
    },
    gray: {
      DEFAULT: '#53565A',
      dark150: '#47494D',
      dark650: '#1D1E1F',
      light150: '#6D6F73',
      light250: '#7E8083',
      light350: '#8F9194',
      light450: '#A0A2A4',
      light650: '#C3C4C5',
      light850: '#E5E6E6',
    },
  },
  surface: {
    page: '#F6F7F7',
  },
  border: {
    header: '#EAEAEB',
    field: '#D4D5D6',
  },
  overlay: {
    DEFAULT: 'rgba(0, 0, 0, 0.5)',
  },
} as const;

const fontWeight = {
  regular: 400,
  medium: 500,
  semiBold: 600,
} as const;

const fontSize = {
  caption: fluidSize(12, 14),
  body: fluidSize(13, 16),
  title: fluidSize(14, 20),
  subtitle: fluidSize(16, 20),
  heading: fluidSize(24, 32),
  eyebrow: '14px',
  input: fluidSize(14, 16),
  disclaimer: fluidSize(10, 12),
  dropdownOption: '12px',
  badge: fluidSize(12, 16),
  sectionTitle: fluidSize(14, 16),
  button: '14px',
  counter: fluidSize(12, 13),
  instruction: '14px',
} as const;

const lineHeight = {
  body: 1.4,
  heading: 1.25,
} as const;

const spacing = {
  none: 0,
  tiny: fluidSize(4, 6),
  smaller: fluidSize(6, 8),
  small: fluidSize(8, 12),
  medium: fluidSize(12, 16),
  default: fluidSize(16, 20),
  large: fluidSize(24, 32),
  cardPadding: fluidSize(8, 24),
  cardIconGap: fluidSize(8, 16),
  pageGutter: fluidSize(16, 71),
  headerLogoPadding: fluidSize(8, 12),
} as const;

const radius = {
  small: 4,
  medium: 8,
  large: 16,
} as const;

const borderWidth = {
  default: 1,
  thick: 1.5,
  stripe: 2,
} as const;

const zIndex = {
  dropdown: 1,
  modal: 1,
} as const;

const dimensions = {
  controlHeight: 37, // Button — altura fixa nos dois breakpoints no Figma
  faqCardMinWidth: 280, // FaqMenu — largura mínima do card ainda não confirmada no Figma
  stepDotSize: 8, // StepIndicator
  stepDotActiveWidth: 20, // StepIndicator — largura do dot da etapa atual
} as const;

const breakpoint = {
  desktop: 768,
} as const;

export const tokens = {
  colors: primitives,
  typography: {
    fontWeight,
    fontSize,
    lineHeight,
  },
  spacing,
  radius,
  borderWidth,
  zIndex,
  dimensions,
  breakpoint,
} as const;

export type Tokens = typeof tokens;
